module.exports = __webpack_public_path__ + "img/industrial.17cbb37c.jpg";